import isEmpty from 'lodash/isEmpty';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import Loader from 'components/Loader';
import { actions, selectors } from 'modules/account/details';

const AccountContainer = ({ children, accountNumber, loading, fetchAccountDetails }) => {
  useEffect(() => {
    if (isEmpty(accountNumber)) return;
    fetchAccountDetails(accountNumber);
  }, [accountNumber, fetchAccountDetails]);

  if (loading) return <Loader />;
  return children;
};

const mapState = (state, { match }) => ({
  accountNumber: match.params.accountNumber,
  loading: selectors.loading(state),
});

const mapDispatch = {
  fetchAccountDetails: actions.fetchAccountDetails,
};

const enhance = compose(withRouter, connect(mapState, mapDispatch));

export default enhance(AccountContainer);
